/**
 * 获取用户信息
 * 目前适用于随管家
 */
import useragent from '@common/useragent'
import { call, uriSuiguanjia } from './bridge'

/**
 * @param {function} [callback] - 回调函数
 */
export default (callback) => {
  if (useragent.isSuiguanjia) {
    const uri = uriSuiguanjia('sgj://api/getUserInfo', {}, 'appRequestUserInfoCallback')
    call(uri, 'appRequestUserInfoCallback', (jsonResult) => {
      callback(jsonResult)
    })
  }
}



// WEBPACK FOOTER //
// ./node_modules/@common/client/src/requestUserInfo.js